import { type MenuItem } from "@client/types";
import withClickOutsideHOC from "@common/hocs/withClickOutside";
import classnames from "classnames";
import * as React from "react";
import Link from "../Link/component";

export type MenuItemProps = {
  item: MenuItem;
  getIsExpanded: (id: string) => boolean;
  onExpand?: (id: string) => void;
  onToggleClick?: (id: string) => React.MouseEventHandler;
  onClickOutside: () => void;
  isClickable: boolean;
  showTitles: boolean;
  style?: React.CSSProperties;
  subMenuStyle?: React.CSSProperties;
  subMenuItemStyle?: React.CSSProperties;
};

const renderItem = (props: MenuItemProps, level: number, ref: React.RefObject<HTMLLIElement> | null) => {
  const isExpanded = props.getIsExpanded(props.item.id);
  return (
    <li
      key={props.item.id}
      ref={ref}
      className={classnames({
        dropdown: level === 0 && props.item.children,
        "dropdown-submenu": level > 0 && props.item.children,
        current: props.item.isCurrent,
        active: props.item.isCurrent,
        expanded: isExpanded
      })}
    >
      <Link
        isClickable={props.isClickable}
        isExpanded={isExpanded}
        onToggleClick={props.onToggleClick}
        item={props.item}
        style={props.style}
      >
        {props.item.label}
        {props.showTitles && props.item.title ? <span className="menu-sub-title">{props.item.title}</span> : null}

        {(props.isClickable || level > 0) && !!props.item.children.length && (
          <i
            className={classnames("toggle", {
              "far fa-angle-up": isExpanded && !!props.onToggleClick,
              "far fa-angle-down": !isExpanded && !!props.onToggleClick
            })}
            onClickCapture={props.onToggleClick ? props.onToggleClick(props.item.id) : undefined}
          />
        )}
      </Link>

      {!!props.item.children.length && (
        <ul className={classnames("dropdown-menu", { "menu-invert": level >= 1 })} style={props.subMenuStyle}>
          {props.item.children.map((item) =>
            renderItem(
              {
                item,
                onToggleClick: props.onToggleClick,
                getIsExpanded: props.getIsExpanded,
                onClickOutside: props.onClickOutside,
                isClickable: props.isClickable,
                style: props.subMenuItemStyle,
                subMenuStyle: props.subMenuStyle,
                subMenuItemStyle: props.subMenuItemStyle,
                showTitles: props.showTitles
              },
              level + 1,
              null
            )
          )}
        </ul>
      )}
    </li>
  );
};

const MenuItem = React.forwardRef((props: MenuItemProps, ref: React.RefObject<HTMLLIElement>) =>
  renderItem(props, 0, ref)
);
export default withClickOutsideHOC<MenuItemProps>(
  MenuItem,
  (props: MenuItemProps) => props.onClickOutside,
  (props: MenuItemProps) => props.getIsExpanded(props.item.id)
);
